<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('bill.batch_update_mapping')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-alert type="warning" class="mb-2">
          <template v-slot:message>
            <div class="messages-list">
              <p>{{ $t('bill.batch_update_mapping_tip') }}<a-button type="link" @click="handleDownloadTemplate">{{$t('system.text_502')}}</a-button></p>
              <p>{{ $t('bill.batch_update_mapping_tip1') }}</p>
              <p>{{ $t('bill.batch_update_mapping_tip2') }}</p>
            </div>
          </template>
        </a-alert>
        <div class="pt-3 pb-3">
          <a-form-item>
            <a-upload-dragger
              v-decorator="decorators.fileList"
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              :accept="accept"
              :remove="handleRemove">
              <div class="pt-3 pb-3">
                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                <p class="ant-upload-text">{{$t('system.text_505')}}</p>
                <p class="ant-upload-hint">{{$t('system.text_506')}}</p>
              </div>
            </a-upload-dragger>
          </a-form-item>
        </div>
     </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import XLSX from 'xlsx'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BillProductsImprotDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      accept: '.xlsx',
      fileList: [],
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        fileList: ['fileList', {
          rules: [
            { required: true, message: this.$t('system.text_507') },
          ],
        }],
      },
    }
  },
  methods: {
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    handleClearFile () {
      this.fileList = []
    },
    handleRemove () {
      this.handleClearFile()
    },
    async handleDownloadTemplate () {
      const res = await new this.$Manager('bill_products').list({
        params: {
          scope: this.$store.getters.scope,
          force_no_paging: true,
          details: true,
        },
      })
      const data = [['ID', this.$t('bill.origin_res_type'), this.$t('bill.product_type'), this.$t('bill.origin_usage_type'), this.$t('bill.text_81')]]
      res.data.data.forEach(item => {
        data.push([item.id, item.origin_res_type, item.product_type, item.origin_usage_type, item.provider])
      })
      const filename = `${this.$t('bill.mapping')}.xlsx`
      const ws_name = 'Sheet1'
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(data)
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, filename)
    },
    genData (sheetData) {
      const ret = []
      sheetData.map(item => {
        const row = {
          id: item.ID,
          product_type: item[this.$t('bill.product_type')],
        }
        ret.push(row)
      })
      return ret
    },
    async handleConfirm () {
      try {
        if (!this.fileList || this.fileList.length === 0) {
          this.form.fc.setFieldsValue({
            fileList: undefined,
          })
        }
        const that = this
        await this.form.fc.validateFields()
        this.loading = true
        var fileReader = new FileReader()
        fileReader.onload = async function (ev) {
          try {
            var data = ev.target.result
            var workbook = XLSX.read(data, {
              type: 'binary',
            }) // 以二进制流方式读取得到整份excel表格对象
            var sheetData = [] // 存储获取到的数据
          } catch (e) {
            throw e
          }
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              sheetData = sheetData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            }
          }
          const ret = that.genData(sheetData)
          that.params.ok(ret)
          that.cancelDialog()
        }
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(this.fileList[0])
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .messages-list p{
    margin-bottom: 2px;
  }
</style>
